import { IModal } from 'customTypes';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import JobTypeALists from '../../pages/sm_setting/setting12/JobTypeALists';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import FoldAll from '../../pages/sm_setting/setting12/FoldAll';
import CountBoxInModal from '../../pages/sm_setting/setting12/CountBoxInModal';
import JobTypeFoldableList from '../../pages/sm_setting/setting12/JobTypeFoldableList';
import { countSelectedAtFoldable } from '../../hooks/useJobType';

const Root = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5010;
  width: 100%;
  height: 100%;
  height: 100vh;
  height: 100dvh;
  background-color: rgba(0, 0, 0, 60%);
  backdrop-filter: blur(0.5rem);
  transition: all ease 0.8s;
  display: flex;
  justify-content: center;
  align-items: center;
  .centered-content {
    height: 100%;
  }
  > .cctvSettingsModal {
    position: relative;
    z-index: 6000;
    display: flex;
    flex-direction: column;
    height: 36rem;
    max-height: calc(100vh - 2rem);
    max-height: calc(100dvh - 2rem);
    width: 32rem;
    background-color: var(--board);
    border-radius: 0.5rem;
    overflow: hidden;
    user-select: none;
    @media screen and (max-width: 1024px) {
      width: calc(100vw - 2rem);
    }
    @media screen and (max-width: 767px) {
      width: 100%;
      height: 100vh;
      height: inherit;
      overflow-y: auto;
      border-radius: 0;
    }
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: var(--text-secondary);
      background-color: var(--tonal);
      border-bottom: 1px solid var(--outline);
      padding: 0.5rem;
      > .titleName {
        font-weight: 600;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0 0.5rem;
      }
      > .closeButton {
        border-radius: 0.5rem;
        margin: 0.25rem;
        padding: 0.25rem;
        display: flex;
        cursor: pointer;
        color: var(--text-disabled);
        &:hover {
          color: var(--text-tertiary);
          background-color: var(--tonal-deep);
          box-shadow: 0 0.25rem 0.75rem 0 rgba(0, 0, 0, 0.2);
        }
      }
    }
    .body {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      gap: 0.75rem;
      overflow-y: scroll;
      padding: 0.5rem 0;
      background-color: var(--tonal-light);
    }
    .result {
      border-top: 1px solid var(--outline);
      display: flex;
      flex-wrap: wrap;
      overflow: auto;
      min-height: 6rem;
      background-color: var(--board);
    }
    .footer {
      display: flex;
      justify-content: flex-end;
      justify-content: space-between;
      background-color: var(--board);
      border-top: 1px solid var(--outline);
      padding: 0.5rem;
      padding-left: 1rem;
      > .button {
        display: flex;
        align-items: center;
        height: 2.5rem;
        min-width: 5.5rem;
        justify-content: center;
        border-radius: 0.25rem;
        font-size: 0.875rem;
        letter-spacing: normal;
        background-color: var(--tonal-deep);
        color: var(--text-tertiary);
        padding: 0 0.5rem;
        cursor: pointer;
        background-color: var(--primary);
        color: var(--text-reverse);
        &:active {
          background-color: var(--filled-blue-deep);
        }
        &.disabled {
          pointer-events: none;
          color: var(--text-disabled);
          background-color: var(--tonal-deep);
          background-color: var(--tonal);
        }
      }
    }
  }
  > .confirmModal {
    position: relative;
    z-index: 6000;
    display: flex;
    flex-direction: column;
    height: 10rem;
    max-height: calc(100vh - 2rem);
    max-height: calc(100dvh - 2rem);
    width: 24rem;
    background-color: var(--board);
    border-radius: 0.5rem;
    overflow: hidden;
    user-select: none;
    .title {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 6rem;
      flex-shrink: 0;
      border-bottom: 1px solid var(--outline);
      .main {
        color: var(--text-tertiary);
      }
      .sub {
        font-weight: 600;
        color: var(--text-secondary);
      }
    }
    .buttons {
      flex-grow: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 0.5em;
      padding: 0.5rem 0.75rem;
      background-color: var(--tonal);
      .button {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 3rem;
        height: 100%;
        width: calc(50% - 0.25rem);
        border-radius: 0.25rem;
        gap: 0.5rem;
        cursor: pointer;
        color: var(--text-tertiary);
        &:hover {
          background-color: var(--board);
          color: var(--text-secondary);
          box-shadow: 0 0.25rem 0.75rem 0 rgba(0, 0, 0, 0.05);
          &:active {
            background-color: var(--tonal-deep);
            color: var(--text-secondary);
            box-shadow: 0 0.25rem 0.75rem 0 rgba(0, 0, 0, 0.1);
          }
        }
      }
    }
  }
`;

interface ICam {
  nCd: string;
  nName: string;
  camList: { cCd: string; cName: string }[];
}

interface ISelectedCam {
  nCd: string;
  cCd: string;
}

type Props = {
  openModal: any;
  setOpenModal: Dispatch<SetStateAction<any>>;
  title: string;
  selectedCamList: ISelectedCam[];
  setSelectedCamList: Dispatch<SetStateAction<ISelectedCam[]>>;
  totalCamList: ICam[];
};

const CameraSelectModal = ({ openModal, setOpenModal, title, selectedCamList, setSelectedCamList, totalCamList }: Props) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState<string[]>([]);
  const [foldList, setFoldList] = useState<{ fold: boolean }[]>([]);
  const subList = totalCamList.map((nvr) => [...nvr.camList.map((cam) => ({ key: `${nvr.nCd}-${cam.cCd}`, name: cam.cName }))]).flat();

  useEffect(() => {
    if (selectedCamList.length > 0) setSelected(selectedCamList.map((item) => `${item.nCd}-${item.cCd}`));
  }, [selectedCamList]);

  useEffect(() => {
    if (totalCamList) {
      const initialFoldList = totalCamList.map(() => ({ fold: true }));
      setFoldList(initialFoldList);
    }
  }, [totalCamList]);

  // 모달 닫기 버튼 클릭 함수
  const onClickClose = () => {
    setOpenModal((prev: IModal) => ({ ...prev, status: false }));
  };

  // 저장 버튼 클릭 함수
  const onClickSave = () => {
    setSelectedCamList(selected.map((item) => ({ nCd: item.split('-')[0], cCd: item.split('-')[1] })));
    setOpenModal((prev: IModal) => ({ ...prev, status: false }));
  };

  const count = countSelectedAtFoldable(subList, selected);
  const totalCount = subList.length;

  return (
    <Root onClick={onClickClose} role='presentation'>
      <div className='cctvSettingsModal' role='presentation' onClick={(event) => event.stopPropagation()}>
        <div className='header'>
          <div className='titleName'>{title}</div>
          <span
            className='material-symbols-rounded closeButton' //
            onClick={onClickClose}
            role='presentation'
          >
            close
          </span>
        </div>

        <div className='body'>
          <FoldAll //
            foldList={foldList}
            setFoldList={setFoldList}
          />
          {totalCamList?.map((nvr: ICam, index: number) => (
            <JobTypeFoldableList
              key={`${nvr.nCd}_${index}`} //
              list={{ grCd: nvr.nCd, grName: nvr.nName, subList: nvr.camList.map((cam) => ({ key: `${nvr.nCd}-${cam.cCd}`, name: cam.cName })) }}
              selected={selected}
              setSelected={setSelected}
              foldList={foldList}
              setFoldList={setFoldList}
              index={index}
              isMultiSelect
            />
          ))}
        </div>
        <div className='footer'>
          <CountBoxInModal
            count={count} //
            totalCount={totalCount}
          />
          <button className='button' type='button' onClick={onClickSave}>
            {t('적용')}
          </button>
        </div>
      </div>
    </Root>
  );
};

export default CameraSelectModal;
